export default "__VITE_ASSET__DxGTiU85__"